import { type ComponentProps } from "react";

export const PlaylistAddCheck = (props: ComponentProps<"svg">) => (
  <svg
    width={props.width ?? "1.875rem"}
    height={props.height ?? "1.875rem"}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M20.25 14.25H3.75V17.25H20.25V14.25Z" fill={props.fill ? props.fill : "#41942A"} />
    <path d="M20.25 8.25H3.75V11.25H20.25V8.25Z" fill={props.fill ? props.fill : "#41942A"} />
    <path d="M14.25 20.25H3.75V23.25H14.25V20.25Z" fill={props.fill ? props.fill : "#41942A"} />
    <path
      d="M30.135 17.145L23.76 23.505L20.58 20.325L18.465 22.44L23.76 27.75L32.25 19.26L30.135 17.145Z"
      fill={props.fill ? props.fill : "#41942A"}
    />
  </svg>
);
